// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RemovedItemNotice-cls1___9bb4d5a3c5f858332f6{/*!*/}.RemovedItemNotice-cls2___c8714cf47131125c1f9{font-size:14px;font-weight:500;line-height:20px;color:#223;padding-top:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RemovedItemNotice-cls1___9bb4d5a3c5f858332f6",
	"cls2": "RemovedItemNotice-cls2___c8714cf47131125c1f9 RemovedItemNotice-cls1___9bb4d5a3c5f858332f6"
};
export default ___CSS_LOADER_EXPORT___;
